import React, { useEffect } from 'react';
import { useUI } from '../../context/UIContext';
import './Snackbar.css';

const Snackbar: React.FC = () => {
  const { snackbar, hideSnackbar } = useUI();

  // Keyed on the whole snackbar: every showSnackbar stores a new object, so a
  // replacement (even with the same message and duration) gets its own full
  // timer instead of being closed by the previous one.
  useEffect(() => {
    if (snackbar.open && snackbar.duration) {
      const timer = setTimeout(() => {
        hideSnackbar();
      }, snackbar.duration);

      return () => clearTimeout(timer);
    }
  }, [snackbar, hideSnackbar]);

  if (!snackbar.open) {
    return null;
  }

  const isCenter = snackbar.position === 'center';

  return (
    <div
      role={snackbar.severity === 'error' ? 'alert' : 'status'}
      aria-live={snackbar.severity === 'error' ? 'assertive' : 'polite'}
      className={`snackbar snackbar--${snackbar.severity} ${snackbar.open ? 'snackbar--open' : ''} ${isCenter ? 'snackbar--center' : ''}`}
      onClick={hideSnackbar}
    >
      <div className="snackbar__content">
        <div className="snackbar__icon">
          {snackbar.severity === 'success' && (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
            </svg>
          )}
          {snackbar.severity === 'error' && (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
          )}
          {snackbar.severity === 'warning' && (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
            </svg>
          )}
          {snackbar.severity === 'info' && (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
            </svg>
          )}
        </div>
        <div className="snackbar__message">{snackbar.message}</div>
        <button 
          className="snackbar__close"
          onClick={(e) => {
            e.stopPropagation();
            hideSnackbar();
          }}
          aria-label="Close"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Snackbar;

